module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAApklEQVQokZ2RvQ0CMQxGX6JUDEDJBsyQ+lY4eiTYiAHYACY4SmZAguIGQJRIoeALuiK20FmyFPtF/vwTcu4KMywCwfCH/jR5BOYoluTAC7C0YJJ0yzZO0RAd2ANbC9YZqw/K74AjcFC+V36of6viTT4qfgLvCXvpPSom5NxZ3dyBFcYOvK3ugYUFk3puVT07RYu31RNw9RStO675ztiyMD3Hr41/4g/JqScpq9Z1gwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/13c.png
// module id = bFFk
// module chunks = 64